import React, { useCallback } from 'react'
import { BoxProps } from 'rebass'
import SBox from 'components/opinionless/SBox'
import { SPageType } from './opinionless/SPage'
import SideBar from './SideBar'
import BrandedSideBarLegacy from './BrandedSideBarLegacy'
import BrandedSideBarLongBeach from './BrandedSideBarLongBeach'

interface Props extends BoxProps {
    pageType: SPageType
    isOpen: boolean
    onClose: (isOpen: boolean) => void
}

const SlidingSideBar: React.FC<Props> = (props: Props) => {
    const { pageType, isOpen, onClose: onCloseProp, sx = {} } = props

    let content = null

    const BRANDED_SIDE_BAR = {
        'Long Beach Pledge': <BrandedSideBarLongBeach pageType={pageType} />,
        Default: <BrandedSideBarLegacy pageType={pageType} />,
    }

    if (pageType === SPageType.Authed) {
        content = <SideBar />
    } else if (pageType === SPageType.Unauthed || SPageType.UnauthedHelpWithSidebar) {
        content = BRANDED_SIDE_BAR[window.PROGRAM.name] || BRANDED_SIDE_BAR['Default']
    } else {
        return null
    }
    const onClose = useCallback(() => {
        onCloseProp(false)
    }, [onCloseProp])

    return (
        <>
            <SBox
                sx={{
                    width: ['100%', '15%', '15%'],
                    flex: ['0', '0 0 15%', '0 0 15%'],
                    minWidth: [0, 240, 240],
                }}
            />
            <SBox
                sx={{
                    position: ['absolute', 'fixed', 'fixed'],
                    width: ['100%', '15%', '15%'],
                    minWidth: 240,
                    height: '100%', // 100vh when fixed
                    pointerEvents: [isOpen ? 'auto' : 'none', 'auto', 'auto'],
                    bg: isOpen ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
                    transition: 'bg 0.3s',
                    zIndex: 10,
                }}
                onClick={onClose}
            >
                <SBox
                    sx={{
                        width: ['80%', '100%', '100%'],
                        height: '100%',
                        bg: 'white',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        justifyContent: 'space-between',
                        zIndex: 1,
                        transform: [`translateX(${!isOpen ? '-100%' : '0'})`, 'none', 'none'],
                        transition: 'transform 0.3s',
                    }}
                >
                    {content}
                </SBox>
            </SBox>
        </>
    )
}

export default SlidingSideBar
